import { useQuery } from 'react-query';
import { videoTagsKeys } from './videoTagsKeys';
import { useToastError } from 'lib/hooks/useToastError';
import { VideoTag } from './types';
import { EXPRESS_API } from 'configs/api/expressApi';
import { useTranslation } from 'react-i18next';

interface IVideoTagsParams {
  start: number;
  limit: number;
  search?: string;
  all?: boolean;
  refresh?: boolean;
}

const getTags = async (data: IVideoTagsParams): Promise<VideoTag[]> => {
  const params = {
    ...data,
    all: data.all ? 'true' : '',
  };
  const res = await EXPRESS_API.get(`/video-tags`, { params });
  return res.data;
};

export const useGetAllTags = (data: IVideoTagsParams) => {
  const { showError } = useToastError();
  const { t } = useTranslation();
  return useQuery(videoTagsKeys.all(), () => getTags(data), {
    onError: e => {
      showError(e, t('There was a problem fetching the tags.'));
    },
    refetchOnMount: true,
    select: tags => tags.sort((a, b) => a.tag.localeCompare(b.tag)),
  });
};
